export enum TABLE_STATUS {
	PENDING = 'Payment pending',
	PAID = 'Paid',
	ACTIVE = 'Active',
	CHECKED_IN = 'CheckedIn',
	CLOSED = 'Closed',
}

export enum PAYMENT_STATUS {
	ALL = 'All',
	PAID = 'Paid',
	PENDING = 'Pending',
}

export enum PAYMENT_METHOD {
	CREDIT_CARD = 'CreditCard',
	CASH_OR_CHECK = 'CashOrCheck',
	PAYPAL = 'Paypal',
	BANK_TRANSFER = 'BankTransfer',
	INVOICE = 'InvoiceLater',
}

export enum SEATS_STATE {
	ALL_SEATS = 'All seats',
	EMPTY_SEATS = 'Empty seats',
}

export enum STATISTIC {
	TABLES_SOLD = 'Tables committed',
	UNKNOWN_GUESTS = 'Unknown Guests',
	SPECIAL_MEALS = 'Special meals',
	AUCTION_ITEMS = 'Auction items',
	CHECKED_IN = 'Checked in',
	AVAILABLE_TICKETS = 'Seats available',
}

export enum MENU_OPTION {
	DETAILS = 'Details',
	MARK_AS_PAID = 'Mark as Paid',
	COLLECT_PAYMENT = 'Collect Payment',
	SEND_PAYMENT_LINK = 'Send Payment Link',
	DELETE = 'Delete',
	GO_TO_PROFILE = 'Go to Profile',
	REMOVE = 'Remove',
	CLOSE = 'Close',
	ACTIVE = 'Active',
	EDIT = 'Edit',
	CHECK_IN = 'Check-in',
	PENDING = 'Pending',
	CANCEL = 'Cancel',
	PATRON_DETAILS = 'Patron Details',
	TABLE_DETAILS = 'Table Details',
	EMAIL_TICKET = 'Email Ticket',
	CANCEL_WIN = 'Cancel Win',
	CANCEL_CHECK_IN = 'Cancel Check-in',
}

export enum ATTENDEE_STATUS {
	CHECKED_IN = 'CheckedIn',
	NOT_CHECKED_IN = 'Not checked in',
	PENDING = 'Pending',
	ALL_ATTENDEES = 'All Attendees',
}

export enum TABLE_VIP_STATUS {
	ALL = 'All',
	ONLY_VIP = 'Only VIP',
}

export enum TABLE_SPECIAL_MEAL {
	ALL = 'All',
	ONLY_SPECIAL_MEAL = 'Only Special Meal',
}
